module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/04-5eb027da3d3bd4f74920d9ff217983cd.png";